import { render, staticRenderFns } from "./PersonInfo.vue?vue&type=template&id=d571e986&scoped=true&v-cloak=true"
import script from "./PersonInfo.vue?vue&type=script&lang=js"
export * from "./PersonInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonInfo.vue?vue&type=style&index=0&id=d571e986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2f37ed56e32c39bf37bd07aa5cbb5c73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d571e986",
  null
  
)

export default component.exports